// extracted by mini-css-extract-plugin
module.exports = {"title-wrapper":"style_title-wrapper__1xRPP","rice-icon":"style_rice-icon__154D8","title":"style_title__38WgB"};